import React from 'react';
import { Spin } from 'antd';
import './FullScreenSpinner.css';

export const FullScreenSpinner = (props) => {
  return (
    <Spin className='FullScreenSpinner' spinning={false} size='large'>
      {props.children}
    </Spin>
  );
};
